import React from "react";
import { Title, Apple } from "./styles";

const Logo = ({ sm }) => {
  return (
    <Title sm={sm}>
      <span
        style={{
          color: "#39ff88",
          fontSize: `${sm ? "24px" : "40px"}`,
        }}
      >
        S
      </span>
      NAPLE
      <Apple sm={sm} />
    </Title>
  );
};

export default Logo;
